module.exports = __webpack_public_path__ + "static/media/ci-icon-payment.1ec64335.svg";